import React, { createContext, useState, useEffect } from "react";
import { useContext } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const HrAppContext = createContext();

export function UseHrApp() {
  return useContext(HrAppContext);
}

export const HrApp = ({ children }) => {
  const [departments, setDepartments] = useState([]); // Here, departments is initialized as an empty array
  const [employees, setemployees] = useState([]);
  const [show, setshow] = useState(false);
  const [text, settext] = useState("");
  const [severity, setseverity] = useState("error");
  const [user, setuser] = useState();
  const [SingleEmployee, setSingleEmployee] = useState({});

  const token = localStorage.getItem("token");

  const Emtoken = localStorage.getItem("EmployeeToken");

  const [EmployeeID, setEmployeeID] = useState("");

  const [stats, setStats] = useState({});

  const [loader, setloader] = useState(true);
  async function getStats() {
    try {
      if (token) {
        const res = await axios({
          url: "https://hr-app-api.onrender.com/employees/stats",
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (res?.data?.status) {
          setStats(res?.data?.data);
          setloader(false);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function GetDepartMents() {
    try {
      const res = await axios({
        url: "https://hr-app-api.onrender.com/api/department/all",
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res?.data?.status) {
        setDepartments(res?.data?.data);
      }
    } catch (error) {
      console.log("depart get error");
    }
  }

  async function GetEmployees() {
    try {
      const res = await axios({
        url: "https://hr-app-api.onrender.com/employees/all",
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res?.data?.status) {
        setemployees(res?.data?.data);
        setloader(false);
      }
    } catch (error) {
      console.log("Employees error");
    }
  }

  async function getSingleEmployee(id) {
    try {
      if (id) {
        const res = await axios({
          url: `https://hr-app-api.onrender.com/employees/employee?id=${id}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (res?.data?.status) {
          setSingleEmployee(res?.data?.data);
          setloader(false);
          console.log(SingleEmployee);
        }
      }
    } catch (error) {
      console.log("error");
    }
  }
  const pathname = useNavigate()

  useEffect(() => {
  }, []);

  return (
    <HrAppContext.Provider
      value={{
        setDepartments,
        departments,
        GetDepartMents,
        setemployees,
        employees,
        GetEmployees,
        setshow,
        token,
        text,
        settext,
        setshow,
        show,
        severity,
        setseverity,
        user,
        setuser,
        Emtoken,
        EmployeeID,
        setEmployeeID,
        SingleEmployee,
        setSingleEmployee,
        getSingleEmployee,
        stats,
        getStats,
        loader,
        setloader,
      }}
    >
      {children}
    </HrAppContext.Provider>
  );
};
